import { motion } from 'framer-motion';

interface BlueprintGridProps {
  opacity?: number;
  color?: string;
  animated?: boolean;
}

export default function BlueprintGrid({ 
  opacity = 15, 
  color = '#169fdb', 
  animated = true 
}: BlueprintGridProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2 }}
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage: `
          linear-gradient(${color}${Math.round(opacity * 2.55).toString(16).padStart(2, '0')} 1px, transparent 1px),
          linear-gradient(90deg, ${color}${Math.round(opacity * 2.55).toString(16).padStart(2, '0')} 1px, transparent 1px)
        `,
        backgroundSize: '50px 50px',
        transform: animated ? 'perspective(1000px) rotateX(60deg)' : 'none'
      }}
    />
  );
}